// DS: i4.24
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Mail: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M9.912 14.826a1 1 0 00.444.167l.12.007h3.048a1 1 0 00.461-.113l.103-.061L21 10.102V18a1 1 0 01-1 1H4a1 1 0 01-1-1v-7.897l6.912 4.723zM3 6a1 1 0 011-1h16a1 1 0 011 1v1.68L13.215 13h-2.431L3 7.68V6z"
      />
    </svg>
  </IconWrap>
);
Mail.displayName = 'Mail';

export default Mail;
